import axiosInstance from "../api/axiosInstance";

const authService = new (class AuthService {
  async login(email, password) {
    const response = await axiosInstance.post("/auth/login", {
      email,
      password,
    });
    return response.data;
  }

  async register(userData) {
    const registerData = {
      firstName: userData.firstName,
      lastName: userData.lastName,
      email: userData.email,
      phoneNumber: userData.phoneNumber,
      password: userData.password,
      confirmPassword: userData.confirmPassword,
      
      // Adres bilgileri - yeni eklenen alanlar dahil
      address: userData.address,
      apartment: userData.apartment,
      company: userData.company,
      city: userData.city,
      district: userData.district,
      postalCode: userData.postalCode,
      country: userData.country,
      
      // Diğer kullanıcı bilgileri
      birthDate: userData.birthDate,
      identityNumber: userData.identityNumber,
      isNewsletterSubscribed: userData.isNewsletterSubscribed
    };
    
    const response = await axiosInstance.post("/auth/register", registerData);
    return response.data;
  }

  async refreshToken(refreshToken) {
    const response = await axiosInstance.post("/auth/refresh-token", {
      refreshToken,
    });
    return response.data;
  }

  async logout() {
    const refreshToken = localStorage.getItem("refreshToken");
    
    try {
      // API'ye çıkış isteği gönder
      if (refreshToken) {
        await axiosInstance.post("/auth/logout", {
          refreshToken,
        });
      }
    } catch (error) {
      console.error("Logout API error:", error);
    } finally {
      // Ne olursa olsun localStorage'ı temizle
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");
    }
  }

  getCurrentUser() {
    const userStr = localStorage.getItem("user");
    if (userStr) return JSON.parse(userStr);
    return null;
  }

  isAuthenticated() {
    return !!localStorage.getItem("token");
  }
})();

export default authService;
